import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import AutoSizeField from '../Common/AutoSizeField';
import styled from 'styled-components';
import {mascCPF, mascCNPJ} from '../Helpers/mascara'

const T = styled(AutoSizeField)`
  padding: 20px 12px;
`

const format = s => {
  if (!s) return ""
  if (s.length === 14) return mascCNPJ(s)
  if (s.length === 11) return mascCPF(s)
  return s
}

const Drawer_ = ({ empresa, drawer, setDrawer, setDialog }) => (
  <Drawer
    anchor="bottom"
    open={drawer}
    onClose={()=>setDrawer(false)}
  >
    <div
      tabIndex={0}
      role="button"
    >
    {empresa.data && <>
      <h1>[{empresa.data.Codigo}] {empresa.data.Apelido} </h1>
      <h2>{empresa.data.RazaoSocial}</h2>
      <div>
        <T label={"Endereço"} value={empresa.data.Endereco} />
        <T label={"Número"} value={empresa.data.Numero} />
        <T label={"Bairro"} value={empresa.data.Bairro} />
        <T label={"CEP"} value={empresa.data.CEP} />
        <T label={"Cidade"} value={empresa.data.Cidade} />
        <T label={"Estado"} value={empresa.data.Estado} />
      </div>
      <div>
        <T label={"Telefone"} value={empresa.data.Telefone} />
        <T label={"E-mail"} value={empresa.data.Email} />
        <T label={"Nome"} value={empresa.data.Nome} />
      </div>
      <div>
        <T label={"Ramo Atividade"} value={empresa.data.RamoAtividade} /> 
      </div>
      <div>
        <T label={"CNPJ"} value={format(empresa.data.CNPJ)} />
        <T label={"Inscrição Estadual"} value={empresa.data.InscricaoEstadual} />
        <T label={"Inscrição Junta Comercial"} value={empresa.data.InscricaoJuntaComercial} />
        <T label={"Inscrição Municipal"} value={empresa.data.InscricaoMunicipal} /> 
      </div>
      <button onClick={()=>setDialog(true)}>Ver Empregados</button>
    </>}
    </div>
  </Drawer>
);

export default Drawer_;
